export type LoginFormState = {
  username: string;
  password: string;
};

export const INITIAL_LOGIN_FORM: LoginFormState = {
  username: '',
  password: '',
};
